<!-- 图册组件 -->
<template>
    <div class="c-picture-content">
        <template v-if="showPreButton">
            <div class="arrow-wrap arrow-wrap__left" :disabled="preDisabled" @click="preClick">
                <i class="el-icon-arrow-left"></i>
            </div>
            <div class="arrow-wrap arrow-wrap__right" :disabled="nextDisabled" @click="nextClick">
                <i class="el-icon-arrow-right"></i>
            </div>
        </template>
        <YScroll class="c-picture-content__piclist-scroll">
            <template>
                <PictureList
                    :data="photoList"
                    @pic-card-click="handlePicCardClick"
                    :cardType="cardType"
                    :bottomShowType="bottomShowType"
                    :topShowType="topShowType"
                >
                    <template v-slot:bottom="scope">
                        <slot name="bottom" :data="scope.data"></slot>
                    </template>
                    <template v-slot:top="scope">
                        <slot name="top" :data="scope.data"></slot>
                    </template>
                    <template v-slot:default="scope">
                        <slot :data="scope.data"></slot>
                    </template>
                </PictureList>
                <el-empty v-if="photoList.length <= 0" description="暂无数据" :image-size="80"> </el-empty>
            </template>
        </YScroll>

        <div class="c-picture-content__page-wrap" v-if="showPagination">
            <el-pagination
                layout="prev, pager, next"
                :current-page.sync="currentPage"
                :pageSize="clonePageSize"
                :total="total"
                @current-change="handlePageChange"
            >
            </el-pagination>
        </div>
    </div>
</template>

<script>
import { YScroll } from '@CommonComponent';
import PictureList from './PictureCard/PictureList.vue';

export default {
    components: {
        PictureList,
        YScroll,
    },
    props: {
        page: {
            type: Number,
            default: 1,
        },
        pageSize: {
            type: Number,
            default: 10,
        },
        total: {
            type: Number,
            default: 0,
        },
        showPreButton: {
            // 是否显示上一页、下一页按钮
            type: Boolean,
            default: true,
        },
        showPagination: {
            // 是否显示分页按钮
            type: Boolean,
            default: true,
        },
        cardType: {
            // 卡片类型
            type: String, // atlas :图集,picture：图片
            default: 'atlas',
        },
        data: {
            type: Array,
            default() {
                return [];
            },
        },
        bottomShowType: {
            // bottom 显示方式,当showBottom为true时有效，hover:鼠标hover时显示,always:一直显示
            type: String,
            validator(val) {
                return ['hover', 'always'].indexOf(val) !== -1;
            },
            default() {
                return 'hover';
            },
        },
        topShowType: {
            // top 显示方式,当showTop为true时有效，hover:鼠标hover时显示,always:一直显示
            type: String,
            validator(val) {
                return ['hover', 'always'].indexOf(val) !== -1;
            },
            default() {
                return 'hover';
            },
        },
    },
    data() {
        return {
            currentPage: this.page,
            totalCount: this.total,
            clonePageSize: this.pageSize,
            // photoList: [
            // {
            //     url: 'https://t7.baidu.com/it/u=4162611394,4275913936&fm=193&f=GIF',
            // },
            // {
            //     url: 'https://t7.baidu.com/it/u=1653900808,1273534310&fm=193&f=GIF',
            // },
            // {
            //     url: 'https://t7.baidu.com/it/u=1653900808,1273534310&fm=193&f=GIF',
            // },
            // {
            //     url: 'https://t7.baidu.com/it/u=2807573989,921590260&fm=193&f=GIF',
            // },
            // ],
            photoList: [...this.data],
        };
    },
    computed: {
        preDisabled() {
            let page = this.currentPage;
            let flag = false;
            if (page <= 1) {
                flag = true;
            }
            return flag;
        },
        nextDisabled() {
            let page = this.currentPage;
            let flag = false;
            let total = this.totalCount;
            let pageSize = this.clonePageSize;
            if (page * pageSize >= total) {
                flag = true;
            }

            return flag;
        },
    },
    methods: {
        // 上一页
        preClick() {
            let page = this.currentPage;
            if (!this.preDisabled) {
                this.currentPage = page - 1;
                this.handlePageChange(this.currentPage);
            }
        },
        // 下一页
        nextClick() {
            let page = this.currentPage;

            if (!this.nextDisabled) {
                this.currentPage = page + 1;
                this.handlePageChange(this.currentPage);
            }
        },
        // 页码改变事件
        handlePageChange(page) {
            this.$emit('update:page', page);
            this.$emit('current-change', page);
        },
        // 图册点击事件
        handlePicCardClick(data) {
            this.$emit('pic-card-click', data);
        },
    },
    watch: {
        page(val) {
            this.currentPage = val;
        },
        pageSize(val) {
            this.clonePageSize = val;
        },
        total(val) {
            this.totalCount = val;
        },
        data(val) {
            this.photoList = [...val];
        },
    },
};
</script>

<style lang="scss" scoped>
.c-picture-content {
    height: 100%;
    width: 100%;
    position: relative;
    .arrow-wrap {
        $h: 100px;
        $w: 54px;
        display: inline-block;
        width: $w;
        height: $h;
        text-align: center;
        line-height: $h;
        background: rgba(0, 0, 0, 0.5);
        cursor: pointer;
        font-size: 34px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        z-index: 100;
        &__left {
            left: -4px;
        }
        &__right {
            right: -4px;
        }
        &[disabled] {
            cursor: not-allowed;
        }
    }
    &__piclist-scroll {
        height: calc(100% - 32px);
    }

    &__page-wrap {
        position: absolute;
        bottom: 0px;
        right: 0px;
        ::v-deep .el-pager li {
            background: transparent !important;
            &.active {
                color: #fff;
                background-color: #154fdb !important;
                border-radius: 2px;
            }
        }
        ::v-deep .el-pagination {
            color: #fff;
        }
        ::v-deep .btn-prev,
        ::v-deep .btn-next {
            background: transparent;
            color: #fff;
        }
    }
}
</style>
